module.exports = __webpack_public_path__ + "img/hair-business-story-newtimeshair-client-todd.8da8cb1a.png";